export default "__VITE_ASSET__CCG2EpkI__"